import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgValuation(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 3.5a.5.5 0 0 1 1 0V12h4.5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5H16v1.5a.5.5 0 0 1-1 0V18H3.5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5H15V3.5Zm0 9.5h-1.25a.507.507 0 0 1-.051.06L9.759 17h1.689l.008-.008L15 13.448V13Zm-2.138 4h1.688l.009-.008.441-.442v-1.688L12.862 17ZM16 17h1.653a.31.31 0 0 1 .008-.008L20 14.653V13h-.044a.507.507 0 0 1-.052.06L16 16.966V17Zm2.55-4h-1.697a.517.517 0 0 1-.052.06l-.801.802v1.688L18.55 13ZM20 16.067l-.933.933H20v-.933ZM8.345 17a.801.801 0 0 1 .009-.008L12.345 13h-1.697a.507.507 0 0 1-.052.06L6.656 17h1.69Zm-3.102 0a.71.71 0 0 1 .008-.008L9.243 13H7.648a.512.512 0 0 1-.052.06l-3.535 3.536a.509.509 0 0 1-.061.052V17h1.243ZM4 15.243 6.243 13H4v2.243ZM4 6v4h1V6H4Zm2 0v4h1V6H6Zm2 0v4h1V6H8Zm2 0v4h1V6h-1Zm2 0v4h1V6h-1ZM9.5 5h4a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h6Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValuation);

var ValuationOutline = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { ValuationOutline as default };
